import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  conversion: {
    affiliate: IdName;
    click_id: number;
    goal: IdName;
    id: number;
    is_approved?: boolean;
    payout: number;
    payout_model: IdName;
    payout_model_id: number;
    revenue: number;
    revenue_model: IdName;
    revenue_model_id: number;
    created_at: number;
    updated_at: number;
    country: string;
    offer: IdName;
    satisfied: boolean;
    currency_code: string;
  };
}

interface IdName {
  id: number;
  name: string;
}
